

import Link from '@src/components/base/Link';

import SidebarItem from './SidebarItem';

const StyleSheet = {
  listItem: {
    '&:has(.Mui-active)': {
      backgroundColor: 'layout.main.light',
    },
  },
  listItemButton: {
    '&.Mui-active': {
      borderLeftColor: 'secondary.main',
    },
  },
};

function SidebarNavItem(props) {
  return (
    <SidebarItem
      component={Link}
      slotProps={{ listItem: { sx: StyleSheet.listItem }, listItemButton: { sx: StyleSheet.listItemButton } }}
      {...props}
    />
  );
}

SidebarNavItem.displayName = 'SidebarNavItem';
export default SidebarNavItem;
